import { Step, StepContent, StepLabel, Stepper } from "@mui/material";
import React, { FC } from "react";
import { RecommendationTranslationStepDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { Card, CardContent, Box, Typography } from "@components/base";

interface Component {
  steps: RecommendationTranslationStepDto[];
}

const Component: FC<Component> = ({ steps }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{t("recommendationSteps.title")}</Typography>
        <Box mt={2.5}>
          <Stepper orientation="vertical">
            {steps.map((step) => (
              <Step key={step.title} active>
                <StepLabel>{t(step.title)}</StepLabel>
                <StepContent>{t(step.text)}</StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Component;
